import { useContext } from "react";
import { ModalInsertContext } from "context/ModalInsertContext";
import style from "./Koszt.module.css";
import DecodeToken from "pages/Login/DecodeToken";

export default function KOSZT_CENA({ koszt }) {
  const contextModalInsert = useContext(ModalInsertContext);
  const handleKosztyDodatkoweZamowienia = contextModalInsert.handleKosztyDodatkoweZamowienia;

  return (
    <td>
      <input
        className={style.nazwa_input}
        type="text"
        value={koszt.cena}
        onChange={(event) => {
          const inputValue = event.target.value;
          const re = /^\d{0,6}(?:[.,]\d{0,2}){0,1}$/;

          if (inputValue === "" || re.test(inputValue)) {
            // 1. Konwersja wpisanej wartości na liczbę (używając kropki dla JavaScriptu)
            const numericCena = parseFloat(inputValue.replace(",", ".")) || 0;
            const numericIlosc = parseFloat(koszt.ilosc) || 0;

            // 2. Obliczenie sumy, zaokrąglenie do 2 miejsc i zamiana kropki na PRZECINEK dla Excela/polskiego formatu
            const obliczonaSuma = (numericCena * numericIlosc)
              .toFixed(2)
              .replace(".", ",");

            handleKosztyDodatkoweZamowienia({
              ...koszt,
              cena: inputValue,
              suma: obliczonaSuma, // Wartość np. "3,15" (z przecinkiem)
              zmienil: DecodeToken(sessionStorage.getItem("token"))?.id,
              update: true,
            });
          }
        }}
      />
    </td>
  );
}